var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thanks"},[_c('h3',[_vm._v("感謝您")]),_c('p',[_vm._v("感謝您的來電")]),_c('a',{attrs:{"href":"/event"}},[_vm._v("回到首頁")])])}]

export { render, staticRenderFns }